export default {
    path: '/agentOperationAfrim',
    name: 'agentOperationAfrim',
    component: () =>
        import(/* webpackChunkName: "agentOperationAfrim" */ "@/pages/agentOperationAfrim/index.vue"),
    meta: {
        title: '代运营确认流程'
    }
}